import { render, staticRenderFns } from "./projectenvironmentDetail.vue?vue&type=template&id=9a349406&"
import script from "./projectenvironmentDetail.vue?vue&type=script&lang=js&"
export * from "./projectenvironmentDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports